<template>
  <div class="web-004-home">
    <carousel
      v-if="rotationList.length"
      :list="rotationList"
    />
    <div
      class="about-yxp"
    >
      <div class="about-yxp-title">
        关于优学派
      </div>
      <div class="tabs">
        <div
          v-for="item in tabs"
          :key="item.name"
          class="item"
          :style="{marginBottom: item.marginBottom}"
        >
          <div class="item-name">
            {{ item.name }}
          </div>
          <div class="item-content">
            {{ item.content }}
          </div>
          <img
            :src="item.img"
            :width="item.imgWidth"
            :style="{marginTop: item.imgMarginTop}"
          >
        </div>
      </div>
    </div>
    <img
      class="static-resources"
      src="@/assets/web004/home/p1.png"
    >
    <div class="core-advantages">
      <div class="core-advantages-top">
        <div class="core-advantages-top-title">
          {{ coreAdvantages.title }}
        </div>
        <div
          v-for="it in coreAdvantages.items"
          :key="it.subtitle.text"
          class="core-advantages-top-item"
        >
          <div class="item-subtitle">
            <img
              :src="it.subtitle.img"
              :alt="it.subtitle.text"
            > {{ it.subtitle.text }}
          </div>
          <div class="item-content">
            <div
              v-for="ct in it.content"
              :key="ct.text"
              class="item-content-div"
            >
              <img
                :src="ct.img"
                :alt="ct.text"
              >
              <span>{{ ct.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="rollingPictureBar-container"
      :style="{backgroundImage: `url(${require('@/assets/web004/home/b1.png')})`}"
    >
      <div class="title">
        荣 誉 ｜ 责任之始，传承之光
      </div>
      <rollingPictureBar :images="honors" />
      <div class="title">
        优学派AI智习室实景
      </div>
      <rollingPictureBar :images="scenes" />
    </div>
  </div>
</template>

<script>
import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
import rollingPictureBar from '../../components/rollingPictureBar.vue';
export default {
    name: 'Web004',
    components: {
        carousel,
        rollingPictureBar,
    },
    data () {
        return {
            websiteMsg: {},
            rotationList: [],
            loading: true,
            tabs: [{
                name: '品牌溯源',
                content: '优学派诞生于中国教育科技高地—深圳，隶属于深圳市优学时代教育电子有限公司，前身为国民教育品牌诺亚舟。26载深耕教育领域，秉持“让学习更高效，让教育更公平”的使命，构建覆盖K12全场景的智慧教育生态，服务超千万家庭。',
                img: require('@/assets/web004/home/tab1.png'),
                imgWidth: '581',
                imgMarginTop: '0px',
                // marginBottom: '40px',
            }, {
                name: '顶尖团队',
                content: '清华、哈佛人才领衔的AI实验室，北京、深圳、成都三大智慧教育研究院，汇聚清北名师、明星外教及行业专家。',
                img: require('@/assets/web004/home/tab2.png'),
                imgWidth: '580',
                imgMarginTop: '18px',
                // marginBottom: '40px',
            }, {
                name: '权威资源',
                content: '覆盖小学至高中全学科，15万+AI精品课件、2千万题库、1.4亿原题讲解视频，助力学生精准提分。',
                img: require('@/assets/web004/home/tab3.png'),
                imgWidth: '601',
                imgMarginTop: '58px',
                // marginBottom: '18px',
            }, {
                name: '科技赋能',
                content: 'AI学情测评、精准学练、智能批改等前沿功能，打造个性化学习方案，提升学习效率！',
                img: require('@/assets/web004/home/tab4.png'),
                imgWidth: '491',
                imgMarginTop: '21px',
                // marginBottom: '56px',
            }],
            tabIndex: 1,
            tabActiveStyle: {
                width: '0px',
                transform: 'translateX(0px)',
            },
            tabImg: '',
            tabImgOpacity: 0,
            coreAdvantages: {
                title: '优学派核心优势',
                items: [
                    {
                        subtitle: {
                            img: require('@/assets/web004/home/top1.png'),
                            text: '产品竞争力',
                        },
                        content: [
                            {
                                img: require('@/assets/web004/home/top4.png'),
                                text: '课程资源更丰富，可运营的产品更多，更好招生',
                            },
                            {
                                img: require('@/assets/web004/home/top5.png'),
                                text: '自研课程体系，资源更优，学习效果更好，更好续费',
                            },
                            {
                                img: require('@/assets/web004/home/top6.png'),
                                text: '一站式解决学习问题，适合晚辅、同步、专项等更多运营场景',
                            },
                            {
                                img: require('@/assets/web004/home/top7.png'),
                                text: '双学习平台，更具市场售卖价值',
                            },
                            {
                                img: require('@/assets/web004/home/top8.png'),
                                text: '督学管理后台完善细致，真正让学习有效果、管理有效率',
                            },
                        ],
                    },
                    {
                        subtitle: {
                            img: require('@/assets/web004/home/top2.png'),
                            text: '盈利能力',
                        },
                        content: [
                            {
                                img: require('@/assets/web004/home/top9.png'),
                                text: '准入门槛更低，轻量运营',
                            },
                            {
                                img: require('@/assets/web004/home/top10.png'),
                                text: '一机多账号，更利于低成本运营',
                            },
                            {
                                img: require('@/assets/web004/home/top11.png'),
                                text: '高配低价，利润空间更大',
                            },
                        ],
                    },
                    {
                        subtitle: {
                            img: require('@/assets/web004/home/top3.png'),
                            text: '服务保障',
                        },
                        content: [
                            {
                                img: require('@/assets/web004/home/top12.png'),
                                text: '自有工厂，品控更严，质量保证',
                            },
                            {
                                img: require('@/assets/web004/home/top13.png'),
                                text: '老品牌，服务网络健全，服务便利快捷',
                            },
                        ],
                    },
                ],
            },
            honors: [
                require('@/assets/web004/home/honor1.png'),
                require('@/assets/web004/home/honor2.png'),
                require('@/assets/web004/home/honor3.png'),
                require('@/assets/web004/home/honor4.jpg'),
                require('@/assets/web004/home/honor5.png'),
                require('@/assets/web004/home/honor6.jpg'),
                require('@/assets/web004/home/honor7.jpg'),
                require('@/assets/web004/home/honor8.jpg'),
                require('@/assets/web004/home/honor9.png'),
                require('@/assets/web004/home/honor10.png'),
                require('@/assets/web004/home/honor11.jpg'),
            ],
            scenes: [
                require('@/assets/web004/home/s1.jpg'),
                require('@/assets/web004/home/s2.jpg'),
                require('@/assets/web004/home/s3.jpg'),
                require('@/assets/web004/home/s4.jpg'),
                require('@/assets/web004/home/s5.jpg'),
                require('@/assets/web004/home/s6.jpg'),
                require('@/assets/web004/home/s7.jpg'),
                require('@/assets/web004/home/s8.jpg'),
                require('@/assets/web004/home/s9.jpg'),
                require('@/assets/web004/home/s10.jpg'),
                require('@/assets/web004/home/s11.jpg'),
                require('@/assets/web004/home/s12.jpg'),
                require('@/assets/web004/home/s13.jpg'),
                require('@/assets/web004/home/s14.png'),
            ],
        };
    },
    computed: {
    },
    async created () {
        const { siteId } = this.$route.query;
        if (!siteId) return;
        const res = await api.getRotationList({
            siteId,
            pageNo: 1,
            pageSize: 999,
        });
        if (res.errcode === 0) {
            this.rotationList = res.data.list.filter(itm => itm.status === 1 && [0, 1].includes(itm.clientType));
        } else {
            this.$message.error(res.errmsg);
        }
        this.loading = false;
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
    },
};
</script>

<style scoped lang="scss">
.web-004-home {
    width: 100%;
    min-height: calc(100vh - 200px);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    .about-yxp {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        background-color: #FFFFFF;
        margin: 0 auto;
        padding-top: 50px;
        background: linear-gradient( 199deg, #FCFDFF 0%, #F7F9FF 100%);
        .about-yxp-title {
            text-align: center;
            color: #141414;
            font-weight: 600;
            font-size: 32px;
            margin-bottom: 40px;
        }
        .tabs {
            width: 1200px;
            display: flex;
            flex-wrap: wrap;
            .item {
                width: 600px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 40px;
                .item-name {
                    width: 100%;
                    color: #1252FF;
                    font-size: 22px;
                    line-height: 30px;
                    text-align: center;
                    font-weight: 600;
                    margin-bottom: 12px;
                }
                .item-content {
                    width: 560px;
                    color: #141414;
                    font-size: 16px;
                    line-height: 30px;
                }
            }
        }
    }
    .static-resources {
        width: 100%;
        display: block;
    }
    .rollingPictureBar-container {
        width: 100%;
        height: 980px;
        background-size: 100%;
        background-repeat: no-repeat;
        .title {
            color: #141414;
            font-size: 32px;
            text-align: center;
            padding-top: 80px;
            padding-bottom: 70px;
            font-weight: 600;
        }
    }
    .core-advantages {
        background: linear-gradient( 180deg, #FFFFFF 0%, #F2F6FF 100%);
        // text-align: center;
        &-top-title, &-middle-title, &-bottom-title {
            font-weight: 600;
            font-size: 32px;
            color: #141414;
            line-height: 45px;
            padding: 40px 0;
            margin: 0 auto;
            text-align: center;
        }

        &-top {
            padding-bottom: 55px;
            &-item {
                width: 1213px;
                background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0.2) 100%);
                border-radius: 12px;
                padding: 30px;
                margin: 0 auto 30px;
                &:last-child {
                    margin-bottom: 0;
                }
                .item-subtitle {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 3px;
                    font-size: 24px;
                    color: #1252FF;
                    font-weight: 600;
                    img {
                        width: 81px;
                        margin-right: 13px;
                    }
                }

                .item-content {
                    .item-content-div {
                        display: inline-flex;
                        align-items: center;
                        margin-right: 76px;
                        width: 320px;
                        margin-top: 40px;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        img {
                            width: 51px;
                            height: 51px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }

        &-middle {
            margin-bottom: 40px;
            &-content {
                &-item {
                    width: 1213px;
                    display: block;
                    margin: 0 auto 51px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        &-bottom {
            margin-bottom: 40px;
            text-align: center;
            &-content-item {
                margin-right: 40px;
                width: 273px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
